// src/data/exercises/L1_06.js

const accountOptions = [
  '現金', '仮払金', '当座預金', '旅費', '仮受金'];

export const L1_06 = {
  title: '簿記　3級（第217-6回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {

        parts: [
        { type: 'ruby', text: '山口', ruby: 'やまぐち' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '従業員', ruby: 'じゅうぎょういん' },
        { type: 'text', value: 'の' },
        { type: 'ruby', text: '出張', ruby: 'しゅっちょう' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '際', ruby: 'さい' },
        { type: 'text', value: 'して，' },
        { type: 'ruby', text: '旅費', ruby: 'りょひ' },
        { type: 'text', value: 'の' },
        { type: 'ruby', text: '概算額', ruby: 'がいさんがく' },
        { type: 'text', value: '￥30,000を' },
        { type: 'ruby', text: '現金', ruby: 'げんきん' },
        { type: 'text', value: 'で' },
        { type: 'ruby', text: '支払', ruby: 'しはら' },
        { type: 'text', value: 'った。' }
    ]
        
        ,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '仮払金', debitAmount: 30000, creditAccount: '現金', creditAmount: 30000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '￥80,000を現金で支払った \n' },
          { type: 'text', value: '①現金で支払われたため、現金の減少（マイナス）です。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に書きます。\n\n', color: 'red', bold: true },
          { type: 'text', value: '旅費の概算額　支払った。\n' },
          { type: 'text', value: '②従業員への出張旅費の概算額の支払いは、仮払金を使います。 \n' },
          { type: 'styled', value: '仮払金を借方（左・Ｄｒ）に書きます。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`￥80,000を現金で支払った。
①現金で支払われたため、現金の減少（マイナス）です。

旅費の概算額　支払った。
②従業員への出張旅費の概算額の支払いは、仮払金を使います。`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
          parts: [
          { type: 'text', value: '￥80,000を現金で支払った \n' },
          { type: 'text', value: '①現金で支払われたため、現金の減少（マイナス）です。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に書きます。\n\n', color: 'red', bold: true },
          { type: 'text', value: '旅費の概算額　支払った。\n' },
          { type: 'text', value: '②従業員への出張旅費の概算額の支払いは、仮払金を使います。 \n' },
          { type: 'styled', value: '仮払金を借方（左・Ｄｒ）に書きます。', color: 'red', bold: true },
        ]
          }
        ],
        
        
      },
    },
  ],
};